import { IFilterElement } from "@saleor/components/Filter";
import { maybe, parseBoolean } from "@saleor/misc";
import {
  PageheaderFilterKeys,
  PageheaderListFilterOpts
} from "@saleor/pageheaders/components/PageheaderListPage";
import {
  PageheaderListUrlFilters,
  PageheaderListUrlFiltersEnum,
  PageheaderListUrlQueryParams
} from "@saleor/pageheaders/urls";
import { PageHeaderFilterInput } from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "pageheaderFilters";

export function getFilterOpts(
  params: PageheaderListUrlFilters
): PageheaderListFilterOpts {
  return {
    isDefault: {
      active: params.isDefault !== undefined,
      value: maybe(() => parseBoolean(params.isDefault, true))
    }
  };
}

export function getFilterVariables(
  params: PageheaderListUrlFilters
): PageHeaderFilterInput {
  return {
    isDefault:
      params.isDefault !== undefined
        ? parseBoolean(params.isDefault, false)
        : undefined,
    search: params.query
  };
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<PageheaderListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  PageheaderListUrlQueryParams,
  PageheaderListUrlFilters
>(PageheaderListUrlFiltersEnum);

export function getFilterQueryParam(
  filter: IFilterElement<PageheaderFilterKeys>
): PageheaderListUrlFilters {
  const { name } = filter;

  switch (name) {
    case PageheaderFilterKeys.isDefault:
      return getSingleValueQueryParam(
        filter,
        PageheaderListUrlFiltersEnum.isDefault,
      );
  }
}
